package site.shadadman.pages.worklog.marketmlm

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initMarketmlmPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/marketmlm/marketmlm.md", FrontMatterElement.Builder { addScalar("title", "MarketMLM Worklog"); }))
}

@Page("/worklog/marketmlm/marketmlm")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun MarketmlmPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("marketmlm") }) {
        org.jetbrains.compose.web.dom.Text("MarketMLM")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/marketmlm/june152017MarketMLMFirstSprint") {
                org.jetbrains.compose.web.dom.Text("First Sprint")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/marketmlm/jul222017MarketmlmOfflineFirst") {
                org.jetbrains.compose.web.dom.Text("Offline First")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/marketmlm/dec182017MarketMLMPaymentMethods") {
                org.jetbrains.compose.web.dom.Text("Payment Methods")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/marketmlm/jan42018MarketmlmMigratingToKMPpart1") {
                org.jetbrains.compose.web.dom.Text("Migrating to KMP - Part 1")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/marketmlm/feb192018MarketmlmMigratingToKMPpart2") {
                org.jetbrains.compose.web.dom.Text("Migrating to KMP - Part 2")
            }
        }
    }
}
